module.exports = __webpack_public_path__ + "static/media/img_placeholder.052f089d.png";